export default __webpack_public_path__ + "static/media/red-4.1ffbad71.png";